import Popover, { PopoverProps } from '@mui/material/Popover';

export const BasePopover = ({ children, ...props }: PopoverProps) => {
  return <Popover {...props}>{children}</Popover>;
};
